import {Configuration} from "./generated";
import axios from "axios";

export const MAIN_SERVER_URL_VOTE="vote.dev.tdd.rl-conseils.net"

export let serverUrlVote = window.location.protocol + "//" + window.location.host;
if (window.location.hostname === "localhost") {
    serverUrlVote = "https://"+MAIN_SERVER_URL_VOTE;
//    serverUrlVote = "http://localhost:8081";
}


export const configVote = new Configuration({});

export const axiosInstanceVote = axios.create({
/*    defaults: {timeout: 180000},
    timeout: 180000*/
});


